import { Box } from "@dbn/omnichannel-design-system-g4p";
import * as classes from "./StickyBottomContainer.css";
type Props = {
  children: JSX.Element;
};

export const StickyBottomContainer = (props: Props) => {
  return (
    <Box column grow className={classes.bottomActionContainer}>
      {props.children}
    </Box>
  );
};
